import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createGallery, updateGallery, getGallery, withBase } from "./api";
import styles from "./Form.module.css";

export default function GalleryAdd() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [image, setImage] = useState(null);
  const [existingImage, setExistingImage] = useState("");
  const [status, setStatus] = useState("");
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (id) {
      setEditId(id);
      getGallery(id)
        .then((res) => {
          if (res.item) {
            setTitle(res.item.title || "");
            setExistingImage(res.item.image_path || "");
          }
        })
        .catch(() => {});
    }
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    setStatus("");

    if (!title.trim()) {
      setStatus("Title is required");
      return;
    }

    const fd = new FormData();
    fd.append("title", title.trim());
    if (image) fd.append("image", image);

    try {
      if (editId) {
        await updateGallery(editId, fd);
      } else {
        await createGallery(fd);
      }
      navigate("/admin/gallery");
    } catch (err) {
      setStatus(err.message || "Failed");
    }
  }

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>{editId ? "Edit Gallery Item" : "Add Gallery Item"}</h2>
      {status && <p className={styles.status}>{status}</p>}
      <form className={styles.grid} onSubmit={onSubmit}>
        <div className={styles.row}>
          <div className={styles.label}>Gallery Title</div>
          <input
            className={styles.input}
            placeholder="Enter gallery title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div className={styles.row}>
          <div className={styles.label}>Upload Image</div>
          <div>
            <input
              className={styles.file}
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files?.[0] || null)}
            />
            {existingImage && !image ? (
              <div style={{ marginTop: 12 }}>
                <div style={{ marginBottom: 8, color: "#374151" }}>Current image</div>
                <img
                  src={withBase(existingImage)}
                  alt="Current gallery"
                  style={{
                    maxWidth: "280px",
                    borderRadius: 12,
                    boxShadow: "0 10px 30px rgba(0,0,0,.12)",
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>

        <div className={styles.actions}>
          <button className={styles.button} type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}
